// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let appVersion: string;

try {
  appVersion = require("../../package.json").version;
} catch (error) {
  console.error("Error: package.json not found. Falling back to default version.");
  appVersion = "0.0.0"; // Provide a default value or handle it as needed
}
const hostname = window?.location?.hostname;
// Detect environment
const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
const production = !isLocal;
// Real Turnstile site key (including localhost) so CF can verify with production secret
const siteKey = '0x4AAAAAABmd0ZiMZfWpJxlX';
export const environment = {
  firebase: {
    apiKey: "AIzaSyCQ4V7xvF0YQn_yo26RpN_AlTZ_vj8_Wak",
    authDomain: "hatchster-firebase-project.firebaseapp.com",
    databaseURL: "https://hatchster-firebase-project.firebaseio.com",
    projectId: "hatchster-firebase-project",
    storageBucket: "hatchster-firebase-project.appspot.com",
    messagingSenderId: "66831674814",
    appId: "1:66831674814:web:d5d05cd6c70dc4bd6bddef",
    measurementId: "G-VE7B2ZP9ZG",
  },
  clarity: {
    projectId: "wcne4x6rr4",
  },
  // HATDEV-100772 PostHog DEV evaluation (project 316045). apiKey is empty in git;
  // DEV deploy injects GitHub Actions secret POSTHOG_DEV_API_KEY before build.
  // Local: set temporarily or export POSTHOG_DEV_API_KEY and run
  // `python .github/scripts/inject-posthog-dev-api-key.py` (do not commit the key).
  posthog: {
    apiKey: "phc_BAbzUthqtpQuNRSzjhUv9A6xZ5KwTLgRUDQhbW8tXJQF",
    apiHost: "https://eu.i.posthog.com",
    uiHost: "https://eu.posthog.com",
  },
  turnstile: {
    siteKey,
    enabled: true
  },
  mirrorPath: 'public_',
  emulateFirebase: false,
  production: false,
  clevertapAccountId: "97Z-R4W-955Z",
  baseURL: "https://devapp.lottosocial.com",
  rollbarAccessToken: "27657fbe41cd4b2abdf5bb5d09c6e6a4",
  webhookUrl: "https://hooks.slack.com/services/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",
  // oneSignalAppId: "e718b3ed-608e-4866-8f48-28cb5b229387",
  oneSignalAppId: "cbab9a0b-3418-4941-9b7a-5142d745e525",
  showProtoTypeLink: true,
  newTranslationBundleUrl:
    "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/translations%2F",
  translationBundleCDNUrl: {
    de: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_de",
    en: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_en",
    es: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_es",
    fr: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_fr",
    it: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_it",
    hi: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_hi",
    pt: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/translates_pt",
  },
  translationBundleZipUrl: {
    de: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_de.zip?alt=media&token=917bc6c2-4c18-498d-b9d8-767ca4404abd",
    en: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_en.zip?alt=media&token=6d55e53f-979a-4f68-96d2-490d729423d4",
    es: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_es.zip?alt=media&token=ea04e921-7ed2-44a8-8824-5872e452d13a",
    fr: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_fr.zip?alt=media&token=b3012734-7deb-4e6a-927f-d3a6e5ffb603",
    it: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_it.zip?alt=media&token=8bb8fc09-97bc-4c0e-afa5-6546fcb75249",
    hi: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_hi.zip?alt=media&token=543b6f11-df54-426c-8245-cd1c91086134",
    pt: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslates_pt.zip?alt=media&token=3a2f50e6-be61-4657-887a-360e07398fdf",
  },
  salesTranslationCDNUrl: {
    de: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_de",
    en: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_en",
    es: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_es",
    fr: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_fr",
    it: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_it",
    hi: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_hi",
    pt: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/sales_translates_pt",
  },
  salesTranslationRemoteBundleUrl: {
    de: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fsales_translates_de.zip?alt=media&token=2c54dea2-5ff9-4bc1-913a-baa872f2c243",
    en: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fsales_translates_en.zip?alt=media&token=36839e7c-e684-485a-b265-40cc2f866105",
    es: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fsales_translates_es.zip?alt=media&token=346114c5-0a09-4425-b7f0-bd1dddb683b4",
    fr: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fsales_translates_fr.zip?alt=media&token=ad151834-871f-4f37-8026-8806a1e74f5e",
    it: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fsales_translates_it.zip?alt=media&token=10c01b4b-7a13-46ba-997d-a1594cb10253",
    hi: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslations_sales_journey_hi.zip?alt=media&token=eb4ae42a-040b-4f45-b163-657bbab665f9",
    pt: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslations_sales_journey_pt.zip?alt=media&token=b917e898-fcc1-4b43-8125-6c7c1626ca78",
  },
  tabsTranslationCDNUrl: {
    de: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_de",
    en: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_en",
    es: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_es",
    fr: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_fr",
    it: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_it",
    hi: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_hi",
    pt: "https://us-central1-hatchster-firebase-project.cloudfunctions.net/ext-firestore-bundle-builder-d3aw-serve/main_tabs_translates_pt",
  },
  tabsTranslationRemoteBundleUrl: {
    de: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fmain_tabs_translates_de.zip?alt=media&token=6ef34164-eb3d-4f0e-9444-5a94b812bf28",
    en: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fmain_tabs_translates_en.zip?alt=media&token=a3ecacc2-3238-4949-a6f6-134b80c96c82",
    es: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fmain_tabs_translates_es.zip?alt=media&token=f1775321-33d2-4d02-a4fb-75bceca51fbc",
    fr: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fmain_tabs_translates_fr.zip?alt=media&token=c6bebda9-ff5c-4a26-89b3-6cd40b067524",
    it: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Fmain_tabs_translates_it.zip?alt=media&token=41cecbc5-06e4-45f2-a622-33c7b127e6dd",
    hi: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslations_main_tabs_hi.zip?alt=media&token=dcd2ddb0-eaa6-4cea-a8fa-96954bef8c2b",
    pt: "https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/bundles%2Ftranslations_main_tabs_pt.zip?alt=media&token=1ec36333-3df7-4890-8d23-018b9bcf652d",
  },
  sourceSiteUrl: "devapp.lottosocial.com",
  paymentWidgetUrl: "https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=",
  cloudFunctions: {
    getCheckoutId: "getcheckoutidv2",
    getPaymentStatus: "getpaymentstatusv2",
    generateCheckOutToken: "generatecheckouttokenv2",
    healthCheckEndpoint: "healthcheckendpoint",
    createCheckoutFlowSession: "createcheckoutflowsessionv2",
    checkoutFlowResponseHandler: "handlecheckoutresponsev3",
  },
  credentials: "credentials",
  applePayMerchantId: "G44zjx3tka.merchant.com.lottosocial.app",
  pwaVersionCheckPath: "/pwa_version/current",
  
  ALLOWED_PAGES_PATH : '/Global_lookup/allowed_page',
  appVersion: appVersion,
  chatbotApiKey: "MdBCcuLbQ_Z_VRVUZHdwBxqU9XfUmOWE",
  recaptcha: {
    siteKey: "6LddmQ4gAAAAACT7kS8nwgeOQKLunFL9Edwsl_jf",
  },
  checkOutUrl: "https://api.sandbox.checkout.com/sessions-interceptor/sid_w35fdpyurafuhbueovbc3olbqa",
  swSchemaVersion: appVersion,
  showDevelopmentPremiumGames: false,
  onSuccessRedirectUrl: "https://europe-west3-hatchster-firebase-project.cloudfunctions.net",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
